import { Component, inject, input, OnInit, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { form, required, FormField } from '@angular/forms/signals';
import { ICategoriaData } from '@core/interfaces/entidades/categoria.entidad';
import { CategoriaApiService } from '@core/services/api/categoria-api.service';
import { LoadingService } from '@shared/services/loading.service';
import { ToastService } from '@shared/services/toast.service';
import { buildDiff } from '@shared/utils/functions.utils';

@Component({
  selector: 'app-editar-categoria',
  imports: [FormField],
  templateUrl: './editar-categoria.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './editar-categoria.css',
})
export class EditarCategoria implements OnInit {
  ngOnInit(): void {
    const cat = this.categoria();
    this.categoriaForm().value.set({
      nombre: cat.nombre,
      descripcion: cat.descripcion,
    });
  }
  // servicios
  private toastService = inject(ToastService);
  private categoriaApiService = inject(CategoriaApiService);
  private loadingService = inject(LoadingService);
  // datos
  isLoading = this.loadingService.loadingSubject;
  categoria = input.required<ICategoriaData>();
  cerrar = output<ICategoriaData | undefined>();
  categoriaForm = form(
    signal({
      nombre: '',
      descripcion: '',
    }),
    (schemaPath) => {
      required(schemaPath.nombre, { message: 'El nombre de la categoría es obligatorio.' });
    },
  );
  private checkInvalidForm(): boolean {
    if (this.categoriaForm().invalid()) {
      this.markAllAsTouched();
      this.toastService.show(
        'top-right',
        'error',
        'Error',
        'Por favor, complete los campos obligatorios.',
      );
      return true;
    }
    return false;
  }
  private markAllAsTouched() {
    this.categoriaForm.nombre().markAsTouched();
  }
  // metodos
  onCerrar(data?: ICategoriaData) {
    this.cerrar.emit(data);
  }
  guardar(event: Event) {
    event.preventDefault();

    if (this.checkInvalidForm()) return;
    const { nombre, descripcion, ...currentValues } = this.categoriaForm().controlValue();

    const dataToSave = {
      ...currentValues,
      nombre: nombre.trim(),
      descripcion: descripcion?.trim() || '',
    };

    const rq: Partial<ICategoriaData> = buildDiff(this.categoria(), dataToSave);
    if (Object.keys(rq).length === 0) {
      this.toastService.show('top-right', 'info', 'Sin cambios', 'No se han realizado cambios.');
      return;
    }
    this.categoriaApiService.editar(this.categoria().id, rq).subscribe({
      next: (data) => {
        this.toastService.show(
          'top-right',
          'success',
          'Éxito',
          'Categoría actualizada correctamente.',
        );
        this.onCerrar(data);
      },
      error: (err) => {
        if (err.status == 401) return;
        this.toastService.show(
          'top-right',
          'error',
          'Error',
          err.error.message || 'Error al actualizar la categoría.',
        );
      },
    });
  }
}
